<template>
  <DialogFormWrapper>
    <template #form>
      <v-form
        id="editOrderDetailsForm"
        ref="editOrderDetailsForm"
        class="w-100 pt-6"
        v-model="isFormValid"
        @submit.prevent="submitEditOrderDetailsForm"
      >
        <v-col cols="12">
          <v-autocomplete
            v-model="clientId"
            :items="clientsList"
            item-value="id"
            item-text="name"
            label="Klient zlecenia"
            placeholder="Wybierz klienta"
            :loading="isFetchingClientsList"
            :disabled="isFetchingClientsList || isProcessing"
            :rules="[rules.required]"
            outlined
            dense
            @input="changeClient"
          />
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            v-model="middlemanId"
            :items="middlemenList"
            item-value="id"
            item-text="name"
            label="Pośrednik"
            placeholder="Wybierz pośrednika"
            :disabled="isFetchingClient || isFetchingClientsList || isProcessing"
            clearable
            outlined
            dense
            @input="setMiddleman"
          />
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            v-model="addressId"
            :items="addresses"
            item-value="id"
            item-text="name"
            label="Adres zlecenia"
            :rules="[rules.required]"
            placeholder="Wybierz adres"
            :loading="isFetchingAddesssesList"
            :disabled="isFetchingAddesssesList"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            v-model="payerId"
            :items="payersList"
            item-value="id"
            item-text="name"
            label="Płatnik zlecenia"
            :rules="[rules.required]"
            placeholder="Wybierz płatnika"
            :disabled="isFetchingClient || isFetchingClientsList || isProcessing"
            outlined
            dense
          />
        </v-col>
      </v-form>
    </template>
    <template #submit>
      <v-btn
        color="primary"
        class="base-hover"
        :disabled="!isFormValid || isProcessing"
        :loading="isProcessing"
        type="submit"
        form="editOrderDetailsForm"
      >
        Edytuj zlecenie
      </v-btn>
    </template>
  </DialogFormWrapper>
</template>

<script>
import DialogFormWrapper from './Partials/DialogFormWrapper'
import rules from '../../utils/validators'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    DialogFormWrapper
  },
  data() {
    return {
      rules,
      isFormValid: true,
      isFetchingClient: false,
      isFetchingClientsList: false,
      isFetchingAddesssesList: false,
      clientId: null,
      middlemanId: null,
      addressId: null,
      payerId: null,
      middlemenList: []
    }
  },
  mounted() {
    this.clientId = this.order.client.id
    this.middlemanId = this.order.middleman?.id || null
    this.addressId = this.order.address.id
    this.payerId = this.order.payer.id

    this.fetchClient(this.clientId)
    this.fetchClientsList()
  },
  beforeDestroy() {},
  computed: {
    ...mapState({
      isProcessing: state => state.orders.isProcessing,
      order: state => state.layout.dialog.item,
      client: state => state.client.entity,
      clientsList: state => state.clients.simplifiedList,
      department: state => state.core.department,
      addresses: state => {
        return state.addresses.items.map(address => ({
          ...address,
          name: address?.name || address?.formattedAddress
        }))
      }
    }),
    payersList() {
      const middleman = this.middlemenList.find(m => m.id === this.middlemanId)
      return [middleman, this.client].filter(Boolean)
    }
  },
  methods: {
    ...mapActions({
      getSimplifiedClients: 'clients/getSimplifiedItems',
      getClient: 'client/getSingleClient',
      getAddresses: 'addresses/getItems',
      editOrder: 'orders/editItem',
      closeDialog: 'layout/closeDialog'
    }),
    submitEditOrderDetailsForm() {
      if (this.$refs.editOrderDetailsForm.validate()) {
        const params = {
          clientId: this.clientId,
          middlemanId: this.middlemanId || null,
          addressId: this.addressId,
          payerId: this.payerId
        }
        this.editOrder({
          tableName: 'orders',
          id: this.order.id,
          params
        }).then(() => {
          this.closeDialog()
        })
      }
    },
    fetchClientsList() {
      this.isFetchingClientsList = true
      this.getSimplifiedClients({ params: {} }).finally(() => {
        this.isFetchingClientsList = false
      })
    },
    fetchAddressesList() {
      this.isFetchingAddesssesList = true
      const payload = {
        params: {
          filters: { clientId: this.middlemanId || this.clientId, departmentIds: [this.department.id] }
        }
      }
      this.getAddresses(payload).finally(() => {
        this.isFetchingAddesssesList = false
      })
    },
    fetchClient() {
      this.isFetchingClient = true
      this.getClient(this.clientId).finally(() => {
        this.middlemenList = this.client.middlemen
        this.isFetchingClient = false
      })
      this.fetchAddressesList()
    },
    setMiddleman() {
      this.addressId = null
      this.payerId = null
      this.fetchAddressesList()
    },
    changeClient() {
      this.middlemanId = null
      this.addressId = null
      this.payerId = null
      this.fetchClient()
    }
  }
}
</script>
